import { uiState } from "../state";

export function getPaddingProp(top, right, bottom, left) {
    return `${top}px ${right}px ${bottom}px ${left}px;`;
}

export function getInnerBorderRadiusProp(br) {
    if (+br > 0) {
        return +br - 1;
    }
    return 0;
}

export function getNumPropVal(val, defaultVal) {
    if (+val >= 0) {
        return val;
    }
    return defaultVal;
}

export function svgToBase64(svg) {
    return btoa(unescape(encodeURIComponent(svg)));
}

export function parseSvgSize(svgString) {
    if (!svgString) return [];
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgString, "image/svg+xml");
    const svgElement = svgDoc.querySelector('svg');
    const width = svgElement.getAttribute('width');
    const height = svgElement.getAttribute('height');
    const defaultSize = uiState.textChat.defaults.defaultSvgIconSize;

    return [width || defaultSize, height || defaultSize];
}